import React, { useEffect, useState } from 'react';
import { setBackHandler, setHeaderTitle } from '../../helpers/header.helper';
import { MediaModel, ReportPhoneNumberStatus, ReportsModel } from '../../models/reports.model';
import { AppTags, buttonLabels, GridStatusLabelVariant, pageTitles, Tags, ToasterTexts } from '../shared/constants';
import { Avatar, Badge, Chip, Grid, IconButton, Paper, Popover, Tooltip } from '@mui/material';
import { UtilityService } from '../../services/UtilityService';
import ImageComponent from '../shared/media/image.component';
import Mention from '../shared/mentions';
import { FileService } from '../../services/FileService';
import ViewFullMedia from '../shared/media/view-full-media.component';
import { ColDef, ColumnApi, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import GridComponent from '../shared/grid';
import { Contact } from '../../models/conversations';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { CustomFilterCategory } from '../shared/filters/filter.model';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { exportToExcel } from '../../helpers/ExportToExcel';
import moment from 'moment';
import { CircularBarChat } from './Circular-Bar-Chat';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { HeaderTemplate } from '../shared/grid/grid.services';
import { computeLength, mapTextToDescendants } from '../shared/mentions/models';
import { DisabledGridIcon, InfoSecondaryIcon, MessageNotSentIcon, MessageDeliveredIcon, ReportAttachFileIcon, FilterPrimaryIcon, BackMobileIcon, RefreshIcon, FilterDarkIcon, MessageSendIcon, DownloadWhiteIcon, VideoIcon } from '../../icon';
import _ from 'lodash';
import FilterComponent from '../shared/filters/filter.component';
import { isMobileDevice } from '../../selectors/selectors';
import ButtonComponent from '../shared/button/button.component';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"

class PhoneNumberData extends ReportsModel {
    Status: ReportPhoneNumberStatus
}

interface IStateProps {
}

interface IProps extends IStateProps {
    Report: ReportsModel;
    Contacts: Contact[];
    IsMobileDevice: boolean;
    IsTeamsApp: boolean;
    CloseViewReport: () => void
}

export const ReportsViewComponent: React.FC<IProps> = (props: IProps) => {
    const report: ReportsModel = props.Report;
    const [openMedia, setOpenMedia] = useState<boolean>(false);
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [ConfirmAction, setConfirmAction] = useState<string>("");
    const [deliveredValue, setDeliveredValue] = useState<number>(0);
    const [failedValue, setFailedValue] = useState<number>(0);
    const [notSentValue, setNotSentValue] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [phoneNumberdata, setPhoneNumberData] = useState<PhoneNumberData[]>([]);
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [sendContacts, setSendContacts] = useState<string[]>([]);
    const [sendValue, setSendValue] = useState<number>(0);
    const [selectedMedia, setSelectedMedia] = useState<MediaModel>()
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    const initialFilterOptions = () => {
        const filterData: any[] = [
            {
                Id: 1,
                Title: "Status",
                IsSelectedAll: false,
                Options: _(phoneNumberdata)
                    .map((row, index) => ({
                        Key: "Status",
                        Id: index + 1,
                        Label: row.Status,
                        Value: row.Status,
                        IsSelected: false
                    }))
                    .uniqBy('Label')
                    .value()
            },
        ]
        setFilterOptions(filterData)
    }

    const handleApplyFilters = (filters: CustomFilterCategory[]) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    useEffect(() => {
        initialFilterOptions()
    }, [phoneNumberdata])

    const isStatusFilterActive = (status: string) => {
        const optionsForStatus = filterOptions.find((option) => option.Title === 'Status')?.Options;
        return optionsForStatus && optionsForStatus.some((option) => option.Label === status && option.IsSelected);
    };

    const handleCircleClick = (status) => {
        const updatedFilterData = filterOptions.map((filter) => {

            let selectedOption = filterOptions?.flatMap((category) => category.Options?.filter((option) => option?.IsSelected))
            if (filter.Title === "Status") {
                if (selectedOption.length > 1) {
                    const updatedOptions = filter.Options.map((option) => ({
                        ...option,

                        IsSelected: option.Label === status ? !option.IsSelected : option.IsSelected,
                    }));
                    return { ...filter, Options: updatedOptions };
                }
                else {
                    const updatedOptions = filter.Options.map((option) => ({
                        ...option,
                        IsSelected: option.Label === status ? !option.IsSelected : false,
                    }));
                    const isSelectedAll = updatedOptions.length === 1 && updatedOptions[0].IsSelected;
                    return { ...filter, Options: updatedOptions, IsSelectedAll: isSelectedAll };
                }
            } else {
                return filter;
            }
        });
        setFilterOptions(updatedFilterData);
        handleApplyFilters(updatedFilterData);
    };

    const resetfilters = () => {
        const updatedFilters = filterOptions.map(filter => ({
            ...filter,
            Options: filter.Options.map(option => ({
                ...option,
                IsSelected: false
            }))
        }));
        setFilterOptions(updatedFilters);
        handleApplyFilters(updatedFilters);

        if (!!columnApi) {
            columnApi.resetColumnState()
        }
        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const ReportsColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "Phone Number",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return getPhoneNumber(params.data.PhoneNumber)
            }
        },
        {
            field: "Status",
            headerName: "Status",
            wrapText: true,
            autoHeight: true,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => { return params.data.Status === ReportPhoneNumberStatus.Delivered ? GridStatusLabelVariant.Active : params.data.Status === ReportPhoneNumberStatus.Failed ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Inactive },

            cellRendererSelector: (params: ICellRendererParams) => {

                if (params.data) {
                    const label = params.data.Status;
                    const variant = params.data.Status === ReportPhoneNumberStatus.Delivered ? GridStatusLabelVariant.Active : params.data.Status === ReportPhoneNumberStatus.Failed ? GridStatusLabelVariant.Danger : params.data.Status === ReportPhoneNumberStatus.Failed ? GridStatusLabelVariant.Inactive : GridStatusLabelVariant.Info;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
    ]

    const ExportReportHeaders = [
        { label: "Name", value: "Name" },
        { label: "Phone Number", value: "PhoneNumber" },
        { label: "Status", value: "Status" }
    ]

    useEffect(() => {
        setHeaderTitle(`Report ${!!props.Report.Campaign?.Name ? `(${props.Report.Campaign?.Name})` : ""}`);
        setBackHandler(props.CloseViewReport);
        progressValue();
        phoneNumberData();
    }, [gridApi, columnApi])

    const getPhoneNumber = (id: string) => {
        return UtilityService.maskPhoneNumberOnLength(id);
    }

    const phoneNumberData = () => {

        if (!report) return;
        const contactMap = new Map();
        [
            ...(report.Contacts || []),
            ...(report.Groups || []).flatMap(g => g.ContactsList || []),
        ].forEach(c => {
            if (c?.Number) {
                contactMap.set(c.Number, c.Name);
            }
        });

        const skippedSet = new Set(report.SkippedContacts || []);
        const deliveredSet = new Set(report.DeliveredContacts || []);
        const bouncedSet = new Set(report.BouncedContacts || []);

        const contacts = (report.Contacts || []).map(x => x.Number) || [];

        const groups = (report.Groups || []).flatMap(x => x?.ContactsList || []).map(y => y.Number);

        const notSent = [...contacts, ...groups].filter(z =>
            !skippedSet.has(z) &&
            !deliveredSet.has(z) &&
            !bouncedSet.has(z)
        );

        setSendContacts(notSent);

        const uniqueNumbers = new Set();
        const result: any[] = [];


        (report.AllContacts || []).forEach((x) => {

            if (uniqueNumbers.has(x)) return;
            uniqueNumbers.add(x);

            const unmask = UtilityService.unmaskPhoneNumberWithPlus(x);

            const formattedNumber = unmask.length === 10 ? `1${unmask}` : getPhoneNumber(unmask);

            let status = ReportPhoneNumberStatus.Sent;

            if (bouncedSet.has(unmask)) {
                status = ReportPhoneNumberStatus.Failed;
            }
            else if (deliveredSet.has(unmask)) {
                status = ReportPhoneNumberStatus.Delivered;
            }
            else if (skippedSet.has(unmask)) {
                status = ReportPhoneNumberStatus.NotSent;
            }

            result.push({
                Name: contactMap.get(x) || "--",
                PhoneNumber: formattedNumber,
                Status: status,
                ID: report.ID,
                TotalContacts: report.TotalContacts,
                Groups: report.Groups,
                SkippedContacts: report.SkippedContacts,
                DeliveredContacts: report.DeliveredContacts,
                BouncedContacts: report.BouncedContacts,
                Message: report.Message,
                Credits: report.Credits,
                Media: report.Media,
                Sent: report.Sent,
                TotalRecords: report.TotalRecords,
                Type: report.Type,
                Contacts: report.Contacts,
                AllContacts: report.AllContacts,
                ReportType: report.ReportType,
                Campaign: report.Campaign,
            });
        });

        setPhoneNumberData(result);
    };


    const mediaDisplay = (media: MediaModel) => {
        setOpenMedia(true)
        setSelectedMedia(media)
    }

    const mediaClose = () => {
        setOpenMedia(false);
        setSelectedMedia(undefined)
    }

    const getMediaDownload = (media: MediaModel) => {
        setShowConfirm(true);
        setConfirmAction("Download")
        setSelectedMedia(media)
    }

    const closeConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim && ConfirmAction === "Download") {
            FileService.fileDownload(selectedMedia)
            setShowConfirm(false)
        }
        else { setShowConfirm(false) }

    }

    const progressValue = () => {
        setDeliveredValue((report.DeliveredContacts?.length / report.TotalContacts) * 100)
        setFailedValue((report.BouncedContacts?.length / report.TotalContacts) * 100)
        setNotSentValue((report.SkippedContacts?.length / report.TotalContacts) * 100)
        setSendValue((sendContacts?.length / report.TotalContacts) * 100)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }
    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const getFilterData = () => {
        return phoneNumberdata
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => resetfilters());

    const getMessageParts = (message: string) => {
        let parts = 0;
        let isGSM = UtilityService.detectIsGSM(message);
        if (isGSM) {
            parts = message.length > 160 ? message.length / 153 : message.length / 160
        } else {
            parts = message.length > 70 ? message.length / 67 : message.length / 70
        }
        return Math.ceil(parts)
    }


    return (
        <>
            {!props.IsMobileDevice ?
                <Grid container className='mx-2 report-viewpage-border  h-v-90 o-y-scroll'>
                    <Grid item md={12} xs={12} xl={12} >
                        <div className={`d-flex justify-between h3-regular  px-3 py-2 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-report-background"}`}>
                            <div> From: {getPhoneNumber(report.PhoneNumber)}</div>
                            <div>{UtilityService.convertToDateWithWeekFormat(
                                report.Sent
                            )}
                                <span>{" " + UtilityService.convertToTimeFormat(report.Sent)}</span>
                                <span className='mx-1'>
                                    ({UtilityService.getPreferedTimeZone()?.OffsetLabel})</span>
                                {(UtilityService.getPreferedTimeZone()?.Name)}
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={12} xs={12} xl={12} >
                        <Paper className={`d-flex justify-between h5-regular ${IsDarkMode ? "bg-color-primary-background " : ""}`} square={true}>
                            <Grid item md={8} xs={12} xl={8} className="px-3 py-2 ">

                                <div className="p-relative mt-1" key={1}>
                                    <div className='report-viewpage-border w-fill h-v-10 br-1 p-relative p-2 o-y-scroll'>

                                        {
                                            !!(props.Report).Groups && (props.Report).Groups.map(x => <Chip
                                                label={x.GroupName}
                                                key={2}
                                                className={"ml-1 mb-1 br-2 custom-color-chip-2"}
                                                avatar={<Avatar className='custom-chip-avatar'> {x.Contacts}</Avatar>}
                                            />)
                                        }
                                        {
                                            !!(props.Report).Contacts && (props.Report).Contacts.map(x => <Chip
                                                key={3}
                                                label={!!x.ContactId ? x.Name ? x.Name : getPhoneNumber(x.Number) : getPhoneNumber(x.Number)}
                                                className={"ml-1 mb-1 custom-color-chip-1"}
                                            />)
                                        }

                                    </div>

                                    <label className=" p-absolute l-1 tn-1 px-1 bg-color-secondary" style={{ borderRadius: "0px 0px 50px 0px" }}>To</label>
                                </div>

                                <div className='d-flex justify-between h6-regular mt-3' style={{ letterSpacing: "0.11px" }}>
                                    <div className='d-flex justify-between h6-regular w-p-50'>
                                        <div>Total Contacts:<span className='color-credits-text ml-1 h6-semibold'>{report.TotalContacts}</span> </div>
                                        <div>Characters:{report.Message !== null ? <span className='color-credits-text ml-1 h6-semibold'>{computeLength(mapTextToDescendants(report.Message, AppTags, false))}</span> : <span className='color-credits-text ml-1 h6-semibold'>0</span>}</div>
                                        <div>Parts:{report.Message !== null ? <span className='color-credits-text ml-1 h6-semibold'> {getMessageParts(report.Message)}</span> : <span className='color-credits-text ml-1 h6-semibold'>0</span>}</div>
                                    </div>

                                    <div>{((report.Type == 1 || report.Type == 2) && report.Groups.length === 0 && report.Contacts.length === 1) ? <span>
                                        1-1 Credits Used:<span className='color-credits-text ml-1 h6-semibold'>{report.Credits}</span></span> : <span>
                                        {report.TotalContacts - report.SkippedContacts?.length === 1 ? "1-1 Credits Used:" : "Group Credits Used:"} <span className='color-credits-text ml-1 h6-semibold'>{report.Credits}</span></span>}
                                    </div>

                                </div>
                            </Grid>

                            <Grid item md={4} xs={12} xl={4} className="mt-1 p-relative">
                                <span className='h5-regular'>Message</span>

                                <Grid item className='w-p-95 h-17 br-2  o-y-scroll px-3 py-2 h5-regular bg-color-report-background ' >
                                    {!!report.Message && <div className='w-p-90  h-p-100'><Mention body={report.Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={report.Message.length} id={''} placeholder={''} readOnly={true} IsLinkAllowed={true} IsOutbound={true} /></div>}
                                    {!!report.Media && <div className='p-absolute b-5 r-5 w-4 report-media-box br-1' >
                                        {report.Media.map(x => <>
                                            {
                                                x.ContentType.startsWith("image") ? <ImageComponent MediaUrl={x.Url} classname={"w-4 h-4 c-pointer mb-1"} mediaDisplay={() => mediaDisplay(x)} /> : x.ContentType.startsWith("video") ? <VideoIcon onClick={() => mediaDisplay(x)} className="w-4 h-4 mb-1" /> : <ReportAttachFileIcon style={{ marginTop: "4px", marginLeft: "4px" }} onClick={(e: any) => { getMediaDownload(x); }} className='mb-1' />
                                            }
                                        </>
                                        )}
                                        {
                                            openMedia &&
                                            <ViewFullMedia media={selectedMedia} open={openMedia} senderName={getPhoneNumber(report.PhoneNumber)} onClose={mediaClose} fileDownload={() => FileService.fileDownload(selectedMedia)} />
                                        }
                                    </div>}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid >
                    <Grid item md={12} xs={12} xl={12} className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-report-background"} `}>
                        <div className='d-flex justify-between px-3 py-2 align-center'>
                            <Grid item md={5} xs={12} xl={5} className='d-flex flex-direction justify-center'>
                                <div className='d-flex my-1 align-center'>
                                    <span className='h3-semibold'>Delivery Statistics</span>
                                    <Tooltip title={<>
                                        <ul className='pl-2'>
                                            <li>Sent: FalkonSMS sent the message and the carrier has accepted the message</li>
                                            <li>Delivered: Message has been delivered successfully</li>
                                            <li>Not Sent: Unsubscribed contacts to whom the message is not initiated</li>
                                            <li>Failed: Message could not be sent</li>
                                        </ul>
                                    </>}>
                                        <InfoSecondaryIcon className='pl-1' />
                                    </Tooltip>
                                    <RefreshIcon className='pl-1 c-pointer' onClick={resetfilters} />
                                </div>
                                <div className='mr-2 h-v-44 mt-2'>
                                    <div className='d-flex justify-around mt-2'>
                                        <CircularBarChat
                                            SquareSize={96}
                                            ProgresValue={sendValue}
                                            StrokeWidth={7}
                                            StatusLabel="Sent"
                                            Icon={<MessageSendIcon fill='##FCBB04' style={{ fill: '##FCBB04' }} className="mr-1" />}
                                            Value={sendContacts?.length}
                                            circleBackground="send-circle-background"
                                            circleProgressColor="send-circle-progress"
                                            IsFilterActive={isStatusFilterActive("Sent")}
                                            OnClickBar={() => handleCircleClick("Sent")}
                                            circleBackgroundHover={true}
                                        />
                                        <CircularBarChat
                                            SquareSize={96}
                                            ProgresValue={deliveredValue}
                                            StrokeWidth={7}
                                            StatusLabel="Delivered"
                                            Icon={<MessageDeliveredIcon className="mr-1" />}
                                            Value={report.DeliveredContacts?.length}
                                            circleBackground="delivered-circle-background"
                                            circleProgressColor="delivered-circle-progress"
                                            IsFilterActive={isStatusFilterActive("Delivered")}
                                            OnClickBar={() => handleCircleClick("Delivered")}
                                            circleBackgroundHover={true}
                                        />
                                    </div>
                                    <div className='d-flex justify-around mt-3'>
                                        <CircularBarChat
                                            SquareSize={96}
                                            ProgresValue={notSentValue}
                                            StrokeWidth={7}
                                            StatusLabel="Not Sent"
                                            Icon={<MessageNotSentIcon className="mr-1" />}
                                            Value={report.SkippedContacts?.length}
                                            circleBackground="notsent-circle-background"
                                            circleProgressColor="notsent-circle-progress"
                                            IsFilterActive={isStatusFilterActive("Not Sent")}
                                            OnClickBar={() => handleCircleClick("Not Sent")}
                                            circleBackgroundHover={true}
                                        />
                                        <CircularBarChat
                                            SquareSize={96}
                                            ProgresValue={failedValue}
                                            StrokeWidth={7}
                                            StatusLabel="Failed"
                                            Icon={<DisabledGridIcon className="mr-1" />}
                                            Value={report.BouncedContacts?.length}
                                            circleBackground=" failed-circle-background"
                                            circleProgressColor="failed-circle-progress"
                                            IsFilterActive={isStatusFilterActive("Failed")}
                                            OnClickBar={() => handleCircleClick("Failed")}
                                            circleBackgroundHover={true}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={7} xs={12} xl={7}>
                                <div className='d-flex justify-between align-center'>
                                    <span className='h3-regular align-center'>
                                        Recipients
                                        <IconButton aria-controls="simple-menu" aria-haspopup="true" tabIndex={5} onClick={handleClickFilter}>
                                            <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }}
                                                badgeContent={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                            >
                                                {Boolean(filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length) ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                                            </Badge>
                                        </IconButton>
                                        <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={handleCloseFilter}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            classes={{ paper: ` ${ShowFilterOptions ? "min-h-40" : ""}` }}
                                            BackdropProps={{
                                                invisible: true,
                                                onClick: (event) => event.stopPropagation(),
                                            }}
                                        >
                                            <FilterComponent
                                                Filters={filterOptions}
                                                HandleApplyFilters={handleApplyFilters}
                                                OnClose={handleCloseFilter}

                                            />
                                        </Popover>
                                    </span>
                                    <ButtonComponent
                                        Variant={"primary-btn-small"}
                                        ClassName='h5-regular d-flex align-center my-0'
                                        OnClick={() => {
                                            exportToExcel(ExportReportHeaders, getFilterData(), `FalkonSMS-Export-Report-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
                                            ).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_REPORT_MESSAGE);
                                        }}
                                        Icon={DownloadWhiteIcon}
                                        ButtonLabel={buttonLabels.DOWNLOAD}
                                    />
                                </div>
                                <Paper className='h-v-45 o-y-hidden p-relative'>
                                    <GridComponent
                                        ColumnDefs={ReportsColoumnDefs}
                                        RowData={phoneNumberdata}
                                        OnGridReady={onGridReady}
                                        IsPaginationEnabled={false}
                                        EmptyLabel={''}
                                        LockVisible={true}
                                        filterOptions={filterOptions}
                                        IsFilterPresent={true}
                                        gridApi={gridApi}
                                    />
                                </Paper>
                            </Grid>
                        </div>
                    </Grid>
                    {
                        showConfirm &&
                        <ConfirmDialog Show={showConfirm}
                            onClose={closeConfirmDialog}
                            ButtonName={"Download"}
                            TextProps={() => <div>
                                Do you want download this file ?
                                <div>
                                    <b>{selectedMedia?.Name}</b>
                                </div>
                            </div>}
                        />
                    }
                </Grid>
                :
                <PullToRefresh isPullable={props.IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-fit'>
                    <Grid container className='report-viewpage-border '>
                        <Grid item xs={12}>
                            <div className='d-flex p-2 box-shadow-display-background-shadow' >
                                {<BackMobileIcon className={"c-pointer pr-2"} onClick={props.CloseViewReport} />}
                                <span className={`h1 my-auto color-add-details-title mr-auto`}>{pageTitles.REPORT + `${!!props.Report.Campaign?.Name ? `(${props.Report.Campaign?.Name})` : ""}`}</span>
                            </div>
                        </Grid>
                        <div className='h-v-100 o-y-scroll w-fill'>
                            <Grid item md={12} xs={12} xl={12} >
                                <div className=' bg-color-report-background px-3 py-2'>
                                    <div className='h2'> From: {getPhoneNumber(report.PhoneNumber)}</div>
                                    <div className='h4 mt-1'>{UtilityService.convertToDateWithWeekFormat(
                                        report.Sent
                                    )}
                                        <span>{" " + UtilityService.convertToTimeFormat(report.Sent)}</span>
                                        <span className='mx-1'>
                                            ({UtilityService.getPreferedTimeZone()?.OffsetLabel})</span>
                                        {(UtilityService.getPreferedTimeZone()?.Name)}
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={12} xs={12} xl={12} >
                                <Paper className=' h5-regular ' square={true}>
                                    <Grid item md={8} xs={12} xl={8} className="px-3 py-2 ">
                                        <div className="p-relative mt-1">
                                            <div className='report-viewpage-border w-fill h-v-20 br-1 p-relative p-2 o-y-scroll'>
                                                {
                                                    !!(props.Report).Groups && (props.Report).Groups.map(x => <Chip
                                                        label={x.GroupName.length > 25 ? UtilityService.trimMessage(x.GroupName, 23) : x.GroupName}
                                                        className={"ml-1 mb-1 br-2 custom-color-chip-2"}
                                                        avatar={<Avatar className='custom-chip-avatar'> {x.Contacts}</Avatar>}
                                                    />)
                                                }
                                                {
                                                    !!(props.Report).Contacts && (props.Report).Contacts.map(x => <Chip
                                                        label={!!x.ContactId ? x.Name ? x.Name.length > 25 ? UtilityService.trimMessage(x.Name, 23) : x.Name : getPhoneNumber(x.Number) : getPhoneNumber(x.Number)}
                                                        className={"ml-1 mb-1 custom-color-chip-1"}
                                                    />)
                                                }
                                            </div>
                                            <label className=" p-absolute l-1 tn-1 px-1 bg-color-secondary" style={{ borderRadius: "0px 0px 90px 0px" }}>To</label>
                                        </div>

                                        <div className=' h6-regular mt-3' style={{ letterSpacing: "0.11px" }}>
                                            <div className='d-flex justify-between h6-regular '>
                                                <div>Total Contacts:<span className='color-credits-text ml-1 h6-semibold'>{report.TotalContacts}</span> </div>
                                                <div>Characters:{report.Message !== null ? <span className='color-credits-text ml-1 h6-semibold'>{computeLength(mapTextToDescendants(report.Message, AppTags, false))}</span> : <span className='color-credits-text ml-1 h6-semibold'>0</span>}</div>
                                                <div>Parts:{report.Message !== null ? <span className='color-credits-text ml-1 h6-semibold'> {getMessageParts(report.Message)}</span> : <span className='color-credits-text ml-1 h6-semibold'>0</span>}</div>
                                            </div>

                                            <div className='mt-1'>{(report.Type == 2 && report.Groups.length === 0 && report.Contacts.length === 1) ? <span>
                                                1-1 Credits Used:<span className='color-credits-text ml-1 h6-semibold'>{report.Credits}</span></span> : <span>
                                                {report.TotalContacts - report.SkippedContacts?.length === 1 ? "1-1 Credits Used:" : "Group Credits Used:"}<span className='color-credits-text ml-1 h6-semibold'>{report.Credits}</span></span>}
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item md={12} xs={12} xl={12} className="p-relative p-3">
                                        <span className='h5-regular'>Message</span>
                                        <Grid item className='h-v-20 br-2 o-y-scroll px-3 py-2 h5-regular bg-color-report-background mt-1' >
                                            {!!report.Message && <div className='w-p-90  h-p-100'><Mention body={report.Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={report.Message.length} id={''} placeholder={''} readOnly={true} /></div>}
                                            {!!report.Media && <div className='p-absolute b-5 r-5 w-4 report-media-box br-1'>
                                                {report.Media.map(x => <>
                                                    {
                                                        x.ContentType.startsWith("image") ? <ImageComponent MediaUrl={x.Url} classname={"w-4 h-4 c-pointer mb-1"} mediaDisplay={() => mediaDisplay(x)} /> : x.ContentType.startsWith("video") ? <VideoIcon onClick={() => mediaDisplay(x)} className="w-4 h-4 mb-1" /> : <ReportAttachFileIcon style={{ marginTop: "4px", marginLeft: "4px" }} onClick={(e: any) => { getMediaDownload(x); }} className='mb-1' />
                                                    }
                                                </>
                                                )}
                                                {
                                                    openMedia &&
                                                    <ViewFullMedia media={selectedMedia} open={openMedia} senderName={getPhoneNumber(report.PhoneNumber)} onClose={mediaClose} fileDownload={() => FileService.fileDownload(selectedMedia)} />
                                                }
                                            </div>}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid >
                            <Grid item md={12} xs={12} xl={12} className="bg-color-report-background">
                                <div className=' py-2 align-center'>
                                    <Grid item md={5} xs={12} xl={5} className="px-3">
                                        <div className='d-flex align-center'>
                                            <span className='h3-semibold'>Delivery Statistics</span>
                                            <RefreshIcon className='pl-1 c-pointer' onClick={resetfilters} />
                                        </div>
                                        <div className='mr-2  mt-2'>
                                            <div className='d-flex justify-around mt-2'>
                                                <CircularBarChat
                                                    SquareSize={96}
                                                    ProgresValue={sendValue}
                                                    StrokeWidth={7}
                                                    StatusLabel="Sent"
                                                    Icon={<MessageSendIcon fill='##FCBB04' style={{ fill: '##FCBB04' }} className="mr-1" />}
                                                    Value={sendContacts?.length}
                                                    circleBackground="send-circle-background"
                                                    circleProgressColor="send-circle-progress"
                                                    IsFilterActive={isStatusFilterActive("Sent")}
                                                    OnClickBar={() => handleCircleClick("Sent")}
                                                />
                                                <CircularBarChat
                                                    SquareSize={96}
                                                    ProgresValue={deliveredValue}
                                                    StrokeWidth={7}
                                                    StatusLabel="Delivered"
                                                    Icon={<MessageDeliveredIcon style={{ fill: "#4cd138" }} className="mr-1" />}
                                                    Value={report.DeliveredContacts?.length}
                                                    circleBackground="delivered-circle-background"
                                                    circleProgressColor="delivered-circle-progress"
                                                    IsFilterActive={isStatusFilterActive("Delivered")}
                                                    OnClickBar={() => handleCircleClick("Delivered")}
                                                />
                                            </div>
                                            <div className='d-flex justify-around mt-3'>
                                                <CircularBarChat
                                                    SquareSize={96}
                                                    ProgresValue={notSentValue}
                                                    StrokeWidth={7}
                                                    StatusLabel="Not Sent"
                                                    Icon={<MessageNotSentIcon className="mr-1" />}
                                                    Value={report.SkippedContacts?.length}
                                                    circleBackground="notsent-circle-background"
                                                    circleProgressColor="notsent-circle-progress"
                                                    IsFilterActive={isStatusFilterActive("Not Sent")}
                                                    OnClickBar={() => handleCircleClick("Not Sent")}
                                                />
                                                <CircularBarChat
                                                    SquareSize={96}
                                                    ProgresValue={failedValue}
                                                    StrokeWidth={7}
                                                    StatusLabel="Failed"
                                                    Icon={<DisabledGridIcon className="mr-1" />}
                                                    Value={report.BouncedContacts?.length}
                                                    circleBackground=" failed-circle-background"
                                                    circleProgressColor="failed-circle-progress"
                                                    IsFilterActive={isStatusFilterActive("Failed")}
                                                    OnClickBar={() => handleCircleClick("Failed")}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item md={7} xs={12} xl={7}>
                                        <div className='d-flex justify-between align-center mt-2 px-3 bg-color-secondary'>
                                            <span className='h3-regular align-center'>
                                                Recipients
                                                <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClickFilter} tabIndex={5}>
                                                    <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }}
                                                        badgeContent={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                                    >
                                                        {Boolean(anchorEl) ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                                                    </Badge>
                                                </IconButton>
                                                <Popover
                                                    open={Boolean(anchorEl)}
                                                    anchorEl={anchorEl}
                                                    onClose={handleCloseFilter}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'left',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left',
                                                    }}
                                                    classes={{ paper: ` ${ShowFilterOptions ? "min-h-40" : ""}` }}
                                                >
                                                    <FilterComponent
                                                        Filters={filterOptions}
                                                        HandleApplyFilters={handleApplyFilters}
                                                        OnClose={handleCloseFilter}
                                                        isReport={true}
                                                    />
                                                </Popover>
                                            </span>
                                            {
                                                props.IsTeamsApp ? "" :
                                                    <ButtonComponent
                                                        Variant={"primary-btn-small"}
                                                        ClassName='h5-regular d-flex align-center'
                                                        OnClick={() => {
                                                            exportToExcel(ExportReportHeaders, getFilterData(), `FalkonSMS-Export-Report-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
                                                            ).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_REPORT_MESSAGE);
                                                        }}
                                                        Icon={DownloadWhiteIcon}
                                                        ButtonLabel={buttonLabels.DOWNLOAD}
                                                    />
                                            }
                                        </div>
                                        <Paper className={`w-p-100 ${!isMobileDevice ? "h-v-40" : `h-v-${((phoneNumberdata.length + 2) * (7))}`} o-y-hidden p-relative paper-background pb-3`}>
                                            <GridComponent
                                                ColumnDefs={ReportsColoumnDefs}
                                                RowData={phoneNumberdata}
                                                OnGridReady={onGridReady}
                                                IsPaginationEnabled={false}
                                                EmptyLabel={''}
                                                LockVisible={true}
                                                filterOptions={filterOptions}
                                                IsFilterPresent={true}
                                                gridApi={gridApi}
                                            />
                                        </Paper>
                                    </Grid>
                                </div>
                            </Grid>
                            {
                                showConfirm && !props.IsTeamsApp &&
                                < ConfirmDialog Show={showConfirm}
                                    onClose={closeConfirmDialog}
                                    ButtonName={"Download"}
                                    IsMobileDevice={props.IsMobileDevice}
                                    TextProps={() => <div>
                                        Do you want download this file ?
                                        <div>
                                            <b>{selectedMedia?.Name}</b>
                                        </div>
                                    </div>}
                                />
                            }
                        </div>
                    </Grid >
                </PullToRefresh>
            }
        </>
    )
}
